import { PREFIX_PRODUCER } from "@/api/Model/ProductOwnerModel";
import AbstractLIORiskCode from "../LIORiskCode";

class LIORiskCode extends AbstractLIORiskCode {
  static getResourceEndpoint() {
    return PREFIX_PRODUCER + '/product-lio-risk-codes-ipr';
  }
}

export default LIORiskCode;
